<template>
  <div class="icons-right">
    <iconPrevList />
    <iconNextList />
    <iconRefreshList class="icon-refresh" v-if="showRefresh" />
  </div>
</template>

<script>
import iconRefreshList from "@/components/listBookArea/headerBookListContainer/iconsUpdateList/iconRefreshList.vue";
import iconNextList from "@/components/listBookArea/headerBookListContainer/iconsUpdateList/iconNextList.vue";
import iconPrevList from "@/components/listBookArea/headerBookListContainer/iconsUpdateList/iconPrevList.vue";
export default {
  props: {
    showRefresh: {
      default: true
    }
  },
  components: {
    iconRefreshList,
    iconNextList,
    iconPrevList
  }
};
</script>

<style lang="scss" scoped>
.icons-right {
  padding-top: 7px;
  width: 70px;
  display: flex;
}
.icons-right svg {
  width: 20.3px;
  height: 20.3px;
  margin-left: 2px;
}
</style>
